import React, {useState, useEffect} from "react";
import API from "../../api";
import {connect} from "react-redux";
import {
    logout,
    receiveApiTokenWeb3,
    setFlashError
} from "../../services/user/actions";

const Web3Button = (props) => {
    const [account, setAccount] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        checkWalletConnection();

        // Poslouchání na změny účtu
        if (window.ethereum) {
            window.ethereum.on('accountsChanged', (accounts) => {
                if (accounts.length > 0) {
                    setAccount(accounts[0]);
                } else {
                    setAccount(null);
                    props.logout();
                }
            });
        }
    }, []);

    const checkWalletConnection = async () => {
        try {
            if (window.ethereum) {
                const accounts = await window.ethereum.request({ method: 'eth_accounts' });
                if (accounts.length > 0) {
                    setAccount(accounts[0]);
                    setIsConnected(true);
                }
            }
        } catch (err) {
            console.error('Error with connection:', err);
        }
    };

    const connectWallet = async () => {
        try {
            setLoading(true);
            setError(null);

            if (!window.ethereum) {
                throw new Error('Web3 wallet not installed in your browser!');
            }

            // Požádáme o připojení účtu
            const accounts = await window.ethereum.request({
                method: 'eth_requestAccounts'
            });
            const account = accounts[0];
            setAccount(account);


            // Získáme nonce ze serveru
            const nonce = await API.getWeb3Nonce(account);

            // Vytvoříme zprávu k podpisu
            const message = `Login to application Neos\n\nAddress: ${account}\n\nNonce: ${nonce.nonce}`;

            // Použijeme personal_sign pro podpis
            const signature = await window.ethereum.request({
                method: 'personal_sign',
                params: [message, account]
            });

            let response = null;
            console.log(props.apiToken);
            if (props.apiToken) {
                response = await API.verifyNonceWithJWT({
                    publicAddress: account,
                    message,
                    signature,
                    nonce: nonce.nonce
                }, props.apiToken);
            } else {
                response = await API.verifyNonce({
                    publicAddress: account,
                    message,
                    signature,
                    nonce: nonce.nonce
                });
            }


            if (!response.token) {
                const errorData = response;
                throw new Error(errorData.error || 'Error at connection');
            }


            // Uložíme JWT token
            props.receiveApiTokenWeb3(response);

            return response;


        } catch (err) {
            props.setFlashError(err.message);
            console.error('Error at login:', err);
            setAccount(null);
        } finally {
            setLoading(false);
        }
    };


    const disconnectWallet = () => {
        setAccount(null);
        localStorage.removeItem('token');
    };

    return (
        <div className="pt-4">

            {!account ? (
                <button
                    onClick={connectWallet}
                    disabled={loading}
                    className="App-button"
                    style={{width: "100%"}}
                >
                    <span>
                        {loading ? 'Logging...' : 'Connect Wallet'}
                    </span>
                </button>
            ) : (
                <div>
                    <p className="mb-4">Connected account: {account}</p>
                    <button
                        onClick={connectWallet}
                        disabled={loading}
                        className="App-button"
                        style={{width: "100%"}}
                    >
                    <span>
                        {loading ? 'Logging...' : 'Continue to Neos'}
                    </span>
                    </button>
                    {/*
                    &nbsp;
                    &nbsp;
                    <button
                        onClick={disconnectWallet}
                        className="App-button"
                    ><span>Disconnect</span>
                    </button>
                    */}
                </div>
            )}
        </div>
    );
}

const mapStateToProps = function (state) {
    return {
        apiToken: state.user.apiToken,
    }
};

export default connect(mapStateToProps, {
    receiveApiTokenWeb3, setFlashError, logout
})(Web3Button);